// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 178) return "static/chunks/syntax-5088eb0765772dbc.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 411 ? "media" : chunkId) + "." + {"81":"ad1a9e2c3c431045","411":"60a285bb87c196cd","907":"886efb993c35b0cb"}[chunkId] + ".js";
};